const STORAGE_KEY_RECEPTION_COMPANY: string = 'competition-list.reception-company';
const STORAGE_KEY_SPECIALITY: string        = 'competition-list.speciality';
const STORAGE_KEY_EDU_FORM: string          = 'competition-list.edu-form';
const STORAGE_KEY_FINANCE_LEVEL: string     = 'competition-list.finance-level';
const STORAGE_KEY_SORTING: string           = 'competition-list.sorting';

export type Enum = {
    value: number|string;
    sys_name: string;
    display_name: string;
}

export type ReceptionCompany = {
    id: number;
    name: string;
    display_name?: string;

    type: Enum;
};

export type Speciality = {
    id: number;
    guid: string;
    code: string;
    name: string;

    full_name: string;
}

export type EduForm = {
    id: number;
    guid: string;
    name: string;
};

export type FinanceLevel = {
    id: number;
    guid: string;
    name: string;
    display_name: string;
};

export async function loadCompanies(): Promise<ReceptionCompany[]> {
    const response = await fetch(route('api.competition-list.reception-companies'));
    return await response.json();
}

export async function loadSpecialities(receptionCompany: number): Promise<Speciality[]> {
    const response = await fetch(route('api.competition-list.specialities', receptionCompany));
    return (await response.json()).sort(function(a: Speciality, b: Speciality): number {
        if(a.code.trim() > b.code.trim()) return 1;
        if(a.code.trim() < b.code.trim()) return -1;
        return 0;
    });
}

export async function loadEduForms(): Promise<EduForm[]> {
    const response = await fetch(route('api.competition-list.edu-forms'));
    return await response.json();
}

export async function loadFinanceLevels(): Promise<FinanceLevel[]> {
    const response = await fetch(route('api.competition-list.finance-levels'));
    return await response.json();
}

export async function loadConcursGroups(receptionCompany: number, speciality: number, eduForm: number, financeLevel: number): Promise<Object[]> {
    const response: Response = await fetch(route('api.competition-list.concurs-groups-v2', {
        receptionCompany: receptionCompany,
        speciality: speciality,
        eduForm: eduForm,
        financeLevel: financeLevel
    }));

    return await response.json();
}

export async function loadPassingScoreInfo(): Promise<Object> {
    const response: Response = await fetch(route('api.competition-list.passing-score-info'));

    return await response.json();
}

export function setStoredCompany(value: null|number): void {
    if (value === null) { localStorage.removeItem(STORAGE_KEY_RECEPTION_COMPANY); }
    else { localStorage.setItem(STORAGE_KEY_RECEPTION_COMPANY, value); }
}

export function getStoredCompany(): null|number {
    if(!localStorage.getItem(STORAGE_KEY_RECEPTION_COMPANY)) {
        return null;
    }

    return Number(localStorage.getItem(STORAGE_KEY_RECEPTION_COMPANY));
}

export function setStoredSpeciality(value: null|number): void {
    if (value === null) { localStorage.removeItem(STORAGE_KEY_SPECIALITY); }
    else { localStorage.setItem(STORAGE_KEY_SPECIALITY, value); }
}

export function getStoredSpeciality(): null|number {
    if(!localStorage.getItem(STORAGE_KEY_SPECIALITY)) {
        return null;
    }

    return Number(localStorage.getItem(STORAGE_KEY_SPECIALITY));
}

export function setStoredEduForm(value: null|number): void {
    if (value === null) { localStorage.removeItem(STORAGE_KEY_EDU_FORM); }
    else { localStorage.setItem(STORAGE_KEY_EDU_FORM, value); }
}

export function getStoredEduForm(): null|number {
    if(!localStorage.getItem(STORAGE_KEY_EDU_FORM)) {
        return null;
    }

    return Number(localStorage.getItem(STORAGE_KEY_EDU_FORM));
}

export function setStoredFinanceLevel(value: null|number): void {
    if (value === null) { localStorage.removeItem(STORAGE_KEY_FINANCE_LEVEL); }
    else { localStorage.setItem(STORAGE_KEY_FINANCE_LEVEL, value); }
}

export function getStoredFinanceLevel(): null|number {
    if(!localStorage.getItem(STORAGE_KEY_FINANCE_LEVEL)) {
        return null;
    }

    return Number(localStorage.getItem(STORAGE_KEY_FINANCE_LEVEL));
}

export function setStoredSorting(value: null|string): void {
    if (value === null) { localStorage.removeItem(STORAGE_KEY_SORTING); }
    else { localStorage.setItem(STORAGE_KEY_SORTING, value); }
}

export function getStoredSorting(): null|string {
    if(!localStorage.getItem(STORAGE_KEY_SORTING)) {
        return null;
    }

    return localStorage.getItem(STORAGE_KEY_SORTING);
}

export function clearStorage(): void {
    localStorage.removeItem(STORAGE_KEY_RECEPTION_COMPANY);
    localStorage.removeItem(STORAGE_KEY_SPECIALITY);
    localStorage.removeItem(STORAGE_KEY_EDU_FORM);
    localStorage.removeItem(STORAGE_KEY_FINANCE_LEVEL);
    localStorage.removeItem(STORAGE_KEY_SORTING);
}
